const updateQueryStringPage = (pageNumber, router) => {
  const searchParams = new URLSearchParams(global.window.location.search);
  if (pageNumber > 1) searchParams.set('page', pageNumber);
  if (pageNumber === 1) searchParams.delete('page');
  const searchParamsString = searchParams.toString();
  const newHref = `${global.window.location.pathname}${searchParamsString ? `?${searchParamsString}` : ''}`;
  const currentSearch = global.window.location.search;
  const currentHref = `${global.window.location.pathname}${currentSearch || ''}`;
  if (currentHref === newHref) return;
  router.replace(newHref, null, { shallow: true });
};

export default updateQueryStringPage;
